<template>
  <v-content class="view-container">
    <navbar-app>
      <template v-slot:filters>
        <v-container>
          <v-toolbar
            class="toolsbar"
            color="transparent"
            flat
            :extended="showExtended"
            style="border-radius: 14px"
          >
            <template
              v-if="showExtended"
              v-slot:extension
            >
              <select-accounts class="mr-5" />
            </template>
            <date-range-picker />
            <v-spacer />
            <button-modal />
            <actions-selection />
            <v-spacer />
            <select-accounts
              v-if="!showExtended"
              class="mr-5"
            />
            <search-list-input class="mr-5" />
            <view-selector v-if="!$mobileDetect.phone()" />
          </v-toolbar>
        </v-container>
      </template>
    </navbar-app>
    <v-container class="pt-0">
      <datatable-view v-if="$store.state.listView" />
      <grid-view v-else />
    </v-container>
    <scroll-top-button-app />
  </v-content>
</template>

<script>
  export default {
    name: 'Home',
    components: {
      NavbarApp: () => import('../components/App/NavbarApp'),
      ScrollTopButtonApp: () => import('../components/App/ScrollTopButtonApp'),
      DateRangePicker: () => import('../components/Home/DateRangePicker'),
      ViewSelector: () => import('../components/Home/ViewSelector'),
      ActionsSelection: () => import('../components/Home/ActionsSelection'),
      SearchListInput: () => import('../components/Home/SearchListInput'),
      SelectAccounts: () => import('../components/Home/SelectAccounts'),
      DatatableView: () => import('../components/Home/DatatableView'),
      GridView: () => import('../components/Home/GridView'),
      ButtonModal: () => import('../components/Home/ButtonModal'),
    },
    computed: {
      showExtended () {
        return this.$mobileDetect.phone() && this.$store.state.accounts.list.length > 1
      },
    },
  }
</script>

<style>
.toolsbar > .v-toolbar__content {
  padding-left: 5px!important
}
</style>
